(function () {
  if (window.__y24gInit) return;
  window.__y24gInit = true;

  function thumbs(g) { return Array.prototype.slice.call(g.querySelectorAll('[data-y24g-thumb]')); }
  function visible(g) { return thumbs(g).filter(function (t) { return !t.hidden; }); }

  function show(g, t) {
    if (!t) return;
    var main = g.querySelector('[data-y24g-main]');
    thumbs(g).forEach(function (x) { x.classList.toggle('is-active', x === t); });
    if (main && main.getAttribute('src') !== t.dataset.src) {
      main.classList.add('is-fading');
      var img = new Image();
      img.onload = img.onerror = function () {
        main.srcset = t.dataset.srcset;
        main.src = t.dataset.src;
        main.width = t.dataset.w; main.height = t.dataset.h;
        main.classList.remove('is-fading');
      };
      img.src = t.dataset.src;
    }
    var lb = g.querySelector('[data-y24g-lbimg]');
    if (lb && g.querySelector('[data-y24g-lightbox]').open) lb.src = t.dataset.full;
    var strip = g.querySelector('[data-y24g-thumbs]');
    if (strip) {
      var l = t.offsetLeft - strip.offsetLeft, r = l + t.offsetWidth;
      if (l < strip.scrollLeft || r > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: l - 8, behavior: 'smooth' });
    }
    count(g);
  }
  function count(g) {
    var v = visible(g), a = g.querySelector('.y24g__thumb.is-active');
    var c = g.querySelector('[data-y24g-count]');
    var i = v.indexOf(a);
    if (c) c.textContent = v.length > 1 ? (i + 1) + ' / ' + v.length : '';
    g.classList.toggle('y24g--single', v.length <= 1);
    var strip = g.querySelector('[data-y24g-thumbs]');
    if (strip) g.classList.toggle('y24g--overflow', strip.scrollWidth > strip.clientWidth + 4);
  }
  function step(g, d) {
    var v = visible(g); if (!v.length) return;
    var i = v.indexOf(g.querySelector('.y24g__thumb.is-active'));
    show(g, v[(i + d + v.length) % v.length]);
  }

  var MAP = null, MAPP = null;
  function loadMap(g) {
    if (MAP) return Promise.resolve(MAP);
    if (!MAPP) MAPP = fetch(g.dataset.map).then(function (r) { return r.json(); }).then(function (j) { MAP = j; return j; }).catch(function () { return null; });
    return MAPP;
  }
  var DIMS = { 'bar type': 0, 'fitting kit': 1, 'lock': 2 };

  function currentOptions(g, v) {
    if (v && v.options) return v.options;
    var section = g.closest('.shopify-section') || document;
    var els = section.querySelectorAll('variant-picker .variant-option'), res = [];
    els.forEach(function (el) {
      var r = el.querySelector('input:checked'), s = el.querySelector('select'), t = el.querySelector('.variant-option__swatch-value');
      res.push(r ? r.value : s ? s.value : t ? t.textContent.trim() : '');
    });
    if (res.length) return res;
    var js = section.querySelector('variant-picker script[type="application/json"]');
    if (js) { try { var o = JSON.parse(js.textContent); if (o && o.options) return o.options; } catch (e) {} }
    return [];
  }

  function apply(g, v) {
    var names = [];
    try { names = JSON.parse(g.dataset.options || '[]'); } catch (e) {}
    if (!names.length) return;
    loadMap(g).then(function (map) {
      if (!map) return;
      var sel = currentOptions(g, v);
      var want = [];
      names.forEach(function (n, i) {
        var d = DIMS[String(n).toLowerCase()];
        if (d === undefined || sel[i] == null) return;
        var idx = map.v[d].indexOf(sel[i]);
        want.push([d, idx]);
      });
      if (!want.length) return;
      var all = thumbs(g), known = 0;
      var match = all.filter(function (t) {
        var e = map.m[t.dataset.mid];
        if (!e) return true;
        known++;
        return want.every(function (w) { return w[1] === -1 || e[w[0]].indexOf(w[1]) !== -1; });
      });
      var specific = match.filter(function (t) { return !!map.m[t.dataset.mid]; });
      if (!specific.length) match = all; // no photos for this combination -> show everything
      all.forEach(function (t) { t.hidden = match.indexOf(t) === -1; });
      var active = g.querySelector('.y24g__thumb.is-active');
      if (!active || active.hidden) show(g, match[0]); else count(g);
    });
  }

  document.addEventListener('click', function (e) {
    var g = e.target.closest('[data-y24g]'); if (!g) return;
    var t = e.target.closest('[data-y24g-thumb]');
    if (t) { show(g, t); return; }
    if (e.target.closest('[data-y24g-prev]')) { step(g, -1); return; }
    if (e.target.closest('[data-y24g-next]')) { step(g, 1); return; }
    var strip = g.querySelector('[data-y24g-thumbs]');
    if (e.target.closest('[data-y24g-sprev]')) { strip.scrollBy({ left: -strip.clientWidth * 0.8, behavior: 'smooth' }); return; }
    if (e.target.closest('[data-y24g-snext]')) { strip.scrollBy({ left: strip.clientWidth * 0.8, behavior: 'smooth' }); return; }
    if (e.target.closest('[data-y24g-zoom]')) {
      var d = g.querySelector('[data-y24g-lightbox]'), a = g.querySelector('.y24g__thumb.is-active');
      if (d && a) { g.querySelector('[data-y24g-lbimg]').src = a.dataset.full; d.showModal(); }
      return;
    }
    if (e.target.closest('[data-y24g-lbclose]') || e.target.matches('[data-y24g-lightbox]')) {
      g.querySelector('[data-y24g-lightbox]').close();
    }
  });
  document.addEventListener('keydown', function (e) {
    var d = document.querySelector('[data-y24g-lightbox][open]'); if (!d) return;
    var g = d.closest('[data-y24g]');
    if (e.key === 'ArrowLeft') step(g, -1);
    if (e.key === 'ArrowRight') step(g, 1);
  });

  // swipe on main image (mobile)
  var sx = null, sy = null;
  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest('.y24g__stage, .y24g__lightbox')) return;
    sx = e.touches[0].clientX; sy = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (sx === null) return;
    var g = e.target.closest('[data-y24g]');
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    sx = null;
    if (g && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(g, dx < 0 ? 1 : -1);
  });

  // variant changes (Horizon)
  function onVariant(e) {
    var v = e && e.detail && e.detail.resource;
    document.querySelectorAll('[data-y24g]').forEach(function (g) { apply(g, v); });
  }
  document.addEventListener('variant:update', onVariant);
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-picker')) setTimeout(function () { onVariant(null); }, 0);
  });

  function initAll() {
    document.querySelectorAll('[data-y24g]').forEach(function (g) {
      if (g.__y24) return; g.__y24 = true;
      count(g); apply(g, null);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  window.addEventListener('resize', function () { document.querySelectorAll('[data-y24g]').forEach(count); });
  new MutationObserver(initAll).observe(document.documentElement, { childList: true, subtree: true });
})();
